import React, { useContext, useEffect } from 'react';
import { PropTypes } from 'prop-types';
import { useTranslation } from 'react-i18next';
import { AppStateContext, AppDispatchContext } from '../../context/AppContext';
import { GROWLER_ERROR } from '../../constants';
import GoBackRedirect from './GoBackRedirect';
import { evaluateGatedAction, GATE_NOT_REVOKED } from '../../utils/vscGating';

// Map gate reasons to the "can't proceed yet" message keys. Reasons without a
// dedicated key fall back to the generic incomplete-data message.
const REASON_MESSAGE_KEYS = {
    [GATE_NOT_REVOKED]: 'gatedAction$error$notRevoked',
};
const DEFAULT_MESSAGE_KEY = 'gatedAction$error$incompleteData';

// Execution-time backstop for the VSC Delete walkway. Re-checks eligibility
// even when the action surface is reached indirectly (stale row, deep link).
const RequireRevokedVsc = ({ children }) => {
    const { device, goBackLink } = useContext(AppStateContext);
    const dispatch = useContext(AppDispatchContext);
    const { t } = useTranslation();
    const { ok, reason } = evaluateGatedAction(device);

    useEffect(() => {
        if (!ok) {
            dispatch({
                type: 'ADD_ERROR',
                errorType: GROWLER_ERROR,
                message: t(REASON_MESSAGE_KEYS[reason] || DEFAULT_MESSAGE_KEY),
            });
        }
    }, [ok, reason, dispatch, t]);

    if (!ok) {
        return <GoBackRedirect path={goBackLink} />;
    }
    return <>{children}</>;
};

RequireRevokedVsc.propTypes = {
    children: PropTypes.node.isRequired,
};

export default RequireRevokedVsc;
